import { Component, OnInit } from "@angular/core"
import { FooterService } from "../../services/footer.service"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"
import Utils from "../../utils/utils"
import { ModalService } from "../modal/modal.service"
import { InformationModalComponent } from "../modals/information-modal/information-modal.component"
import { FeedbackModalComponent } from "./feedback-modal/feedback-modal.component"
import { AuthModalComponent } from "../modals/auth-modal/auth-modal.component"
import { Router } from "@angular/router"
import { ResourceService } from "../../services/resource.service"
import { STATIC_IMAGES } from "../../models/constants"

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent extends EduComponent implements OnInit {
    public feedbackFormHtml = null
    public gtmPrefix: string = "gtm-footer-"
    public pbsLogoWhite
    public currentYear

    constructor(
        private footerService: FooterService,
        private modalService: ModalService,
        public userService: UserService,
        private resourceService: ResourceService,
        public router: Router
    ) {
        super()
        this.pbsLogoWhite = STATIC_IMAGES.pbs_logo_white
    }

    public ngOnInit() {
        this.currentYear = Utils.getCurrentYear()
    }

    public teacherLogin() {
        if (window.location.pathname === "/student/") {
            this.router.navigate(["/"])
        } else {
            this.resourceService.switchResourceView(null, null)
        }
        this.modalService.open(AuthModalComponent)
    }

    public changeUserExperience(studentState: boolean) {
        this.userService.switchUserExperience(studentState, "_self")
    }
    public openFeedbackForm(event) {
        event.preventDefault()
        this.modalService.open(FeedbackModalComponent, { size: "lg" })
    }

    public subscribe() {
        const settings = (window as any).PBSLM.eloqua.footer
        const subscribeBtn = document.getElementById("eloqua-newsletter-go")
        if (subscribeBtn.getAttribute("disabled") === "true") {
            return
        }
        const email = (document.getElementById("email-eloqua-newsletter") as HTMLInputElement).value
        subscribeBtn.classList.add("disabled")
        subscribeBtn.setAttribute("disabled", "true")

        this.addSub(
            this.footerService
                .subscribeToNewsletter(
                    settings.url,
                    settings.elqFormName,
                    settings.elqSiteId,
                    email
                )
                .subscribe(
                    (response) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        this.modalService.open(InformationModalComponent, {
                            data: {
                                message: "You have been subscribed to the newsletter!",
                            },
                        })
                    },
                    (error) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        this.modalService.open(InformationModalComponent, {
                            data: {
                                message: "Something went wrong. Please try again later.",
                            },
                        })
                    }
                )
        )
    }
}
